'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isFuture;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isFuture.js
// module id = 543
// module chunks = 0